import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ShSelectComponent } from '../../ui/sh-select/sh-select.component';
import { ShToggleAccessorComponent } from '../../ui/sh-toggle-accessor/sh-toggle-accessor.component';

@Component({
    selector: 'app-settings-user-settings-section',
    standalone: true,
    templateUrl: './settings-user-settings-section.component.html',
    imports: [ReactiveFormsModule, ShToggleAccessorComponent, ShSelectComponent, TranslatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsUserSettingsSectionComponent {
    public userSettingsForm = input.required<FormGroup>();
    public pageSizeOptions = input.required<{ label: string; value: string }[]>();
}
